<canvas #bgCanvas class="bg-canvas" aria-hidden="true"></canvas>
